import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/adUnits`;

const adunitService = {
  // ✅ Get all ad units
  getAdUnits: async () => {
    const response = await axios.get(BASE_URL);
    return response.data;
  },

  // ✅ Create a new ad unit
  createAdUnit: async (data) => {
    const response = await axios.post(BASE_URL, data);
    return response.data;
  },

  // ✅ Update an existing ad unit
  updateAdUnit: async (id, data) => {
    const response = await axios.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  // ✅ Delete an ad unit
  deleteAdUnit: async (id) => {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default adunitService;
